import { render, staticRenderFns } from "./WaitWork.vue?vue&type=template&id=fa6d7f66&scoped=true&"
import script from "./WaitWork.vue?vue&type=script&lang=js&"
export * from "./WaitWork.vue?vue&type=script&lang=js&"
import style0 from "./WaitWork.vue?vue&type=style&index=0&id=fa6d7f66&lang=less&scoped=true&"
import style1 from "./WaitWork.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6d7f66",
  null
  
)

export default component.exports